import React from "react";
import SignupHead from "../../component/AuthHead/SignupHead";
import { Button, Col, Container, Form, Modal, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

const Signup = () => {
  return (
    <div>
      <SignupHead />
      <section id="service-details" className="service-details">
        <div className="container" data-aos="fade-up" data-aos-delay="100">
          <div className="row gy-4 mobcol">
            <div className="col-lg-12">
              <Container style={{ width: "50%" }}>
                <Form>
                  <Row>
                    <Col xs={12} md={6}>
                      <Form.Group
                        className="mb-3"
                        controlId="exampleForm.ControlTextarea1"
                      >
                        <Form.Label>First Name</Form.Label>
                        <Form.Control type="text" />
                      </Form.Group>
                    </Col>
                    <Col xs={12} md={6}>
                      <Form.Group
                        className="mb-3"
                        controlId="exampleForm.ControlTextarea1"
                      >
                        <Form.Label>Last Name</Form.Label>
                        <Form.Control type="text" />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Form.Group
                    className="mb-3"
                    controlId="exampleForm.ControlTextarea1"
                  >
                    <Form.Label>Email</Form.Label>
                    <Form.Control type="email" />
                  </Form.Group>
                  <Form.Group
                    className="mb-3"
                    controlId="exampleForm.ControlTextarea1"
                  >
                    <Form.Label>Password</Form.Label>
                    <Form.Control type="password" />
                  </Form.Group>
                  <Button className="battoun">Sign Up</Button>

                  <p
                    style={{
                      textAlign: "center",
                      fontSize: "12px",
                      paddingTop: "5px",
                      paddingRight: "5px",
                    }}
                  >
                    Already have an account?
                    <Link to={"/login"}> Login </Link>
                  </p>
                </Form>
              </Container>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Signup;
